import React from 'react';
import {Card} from "react-bootstrap";
//TODO looks like antipattern, Atom requires a component..
/**
 * PageCardWrapper component wraps content inside a Bootstrap Card component with an optional title.
 * @param {Object} props - Component props
 * @param {string} props.title - The title of the card (optional)
 * @param {React.ReactNode} props.children - The content to be wrapped inside the card
 * @returns {JSX.Element} - JSX element representing the PageCardWrapper component
 */
export default function PageCardWrapper({ title, children }) {
    return (
        <Card className="input-round-corners mb-3">
            {title && <Card.Header>{title}</Card.Header>}
            {children}
        </Card>
    );
}
